module.exports = __webpack_public_path__ + "static/img/menu14.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/menu14.png
// module id = 555
// module chunks = 0